import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";
import { Logo, AironixBadge, Spinner } from "../components/Logo";
import { ShieldCheck, ShieldX, ShieldAlert } from "lucide-react";

export default function VerifyCertificate() {
  const { vid } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api.get(`/certificates/verify/${vid}`)
      .then((r) => setState({ loading: false, data: r.data }))
      .catch((e) => setState({ loading: false, error: e.response?.data?.detail || "Certificate not found" }));
  }, [vid]);

  return (
    <div className="min-h-screen bg-[#0B1120] grid-bg flex flex-col">
      <header className="glass border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/"><Logo className="h-9" withText /></Link>
          <AironixBadge />
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-lg">
          {state.loading ? <Spinner label="Verifying certificate..." /> : (
            <div className="card p-8 text-center animate-fadeup" data-testid="verify-result">
              {state.error || !state.data?.valid ? (
                <>
                  {state.data && state.data.status === "revoked" ? <ShieldAlert className="mx-auto text-amber-400" size={56} /> : <ShieldX className="mx-auto text-red-400" size={56} />}
                  <h1 className="font-heading text-2xl font-bold mt-4">{state.data?.status === "revoked" ? "Certificate Revoked" : "Not Verified"}</h1>
                  <p className="text-slate-400 mt-2">{state.error || "This certificate has been revoked and is no longer valid."}</p>
                  {state.data?.status === "revoked" && (
                    <div className="mt-6 text-left bg-[#0B1120] rounded-lg p-4 border border-white/5 text-sm space-y-1">
                      <p><span className="text-slate-500">Holder:</span> {state.data.holder}</p>
                      <p><span className="text-slate-500">Certificate:</span> {state.data.title}</p>
                      <p><span className="text-slate-500">Status:</span> <span className="text-amber-400 capitalize">{state.data.status}</span></p>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <ShieldCheck className="mx-auto text-emerald-400" size={56} />
                  <h1 className="font-heading text-2xl font-bold mt-4">Verified Authentic</h1>
                  <p className="text-slate-400 mt-2">This certificate was issued by InfosecGig Academy.</p>
                  <div className="mt-6 text-left bg-[#0B1120] rounded-lg p-5 border border-white/5 text-sm space-y-2">
                    <p><span className="text-slate-500">Holder:</span> <span className="font-medium text-white">{state.data.holder}</span></p>
                    <p><span className="text-slate-500">Certificate:</span> {state.data.title}</p>
                    {state.data.path && <p><span className="text-slate-500">Path:</span> {state.data.path}</p>}
                    <p><span className="text-slate-500">Issued:</span> {new Date(state.data.issued_at).toLocaleDateString()}</p>
                    <p className="font-mono text-xs"><span className="text-slate-500">ID:</span> {state.data.verification_id}</p>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
